export default class YandexMetrikaNavigationTracker {
  constructor(windowObject, documentObject, counterId) {
    this.window = windowObject;
    this.document = documentObject;
    this.counterId = Number.parseInt(counterId, 10);
    this.lastUrl = windowObject.location.href;
    this.observer = null;
  }
  start() {
    const title = this.document.querySelector('title');
    if (this.observer || !title || !Number.isSafeInteger(this.counterId)) return false;

    // Flarum меняет title после завершения SPA-перехода. Наблюдение за ним позволяет
    // отправлять один hit уже с окончательным URL и заголовком, не вмешиваясь в маршрутизатор.
    this.observer = new this.window.MutationObserver(() => this.trackCurrentPage());
    this.observer.observe(title, {
      childList: true,
      subtree: true,
      characterData: true
    });
    return true;
  }
  trackCurrentPage() {
    const currentUrl = this.window.location.href;
    if (currentUrl === this.lastUrl) return;
    const previousUrl = this.lastUrl;
    this.lastUrl = currentUrl;
    if (typeof this.window.ym !== 'function') return;
    this.window.ym(this.counterId, 'hit', currentUrl, {
      title: this.document.title,
      referrer: previousUrl
    });
  }
}
flarum.reg.add('devconnect-seo', 'forum/service/YandexMetrikaNavigationTracker', YandexMetrikaNavigationTracker);